var EAuthentication;

(function (EAuthentication) {
  EAuthentication[EAuthentication["NotAuthenticated"] = 0] = "NotAuthenticated";
  EAuthentication[EAuthentication["Golden"] = 2] = "Golden";
  EAuthentication[EAuthentication["Blue"] = 3] = "Blue";
})(EAuthentication || (EAuthentication = {}));

export { EAuthentication };
